import { r as registerInstance, c as createEvent, h, f as forceUpdate, H as Host, g as getElement } from './index-ce7d0cf1.js';
import { b as getEnv, c as getConfig, d as getTrumpfUserClient, a as getAuthClient } from './index-b34238aa.js';
import { i as i18nProvider } from './index-5a73d8b4.js';
import { d as debounce } from './debounce-9c93e0a1.js';
import { i as isStringNotEmpty } from './type-check-5fa494e1.js';
import { g as getNotificationProvider } from './backend-8895d157.js';

const headerDialogs = {
    APP_LAUNCHER: "app-launcher",
    BURGER_MENU: "burger-menu",
    HOME: "home",
    USER: "user",
    SETTINGS: "settings",
    NOTIFICATIONS: "notifications",
    HELP: "help",
    INFO: "info"
};
const headerIcons = {
    APP_LAUNCHER: "uic:appswitcher",
    BURGER_MENU: "uic:burger",
    HOME: "uic:apps",
    USER: "uic:user",
    SETTINGS: "uic:settings",
    NOTIFICATIONS: "uic:notifications",
    HELP: "uic:help"
};

const getTrumpfBaseUrl = () => (getEnv() === "qa" ? "https://www-q.trumpf.com/" : "https://www.trumpf.com/");
const getShopUrl = () => (getEnv() === "qa" ? "https://www.shop-preprod.trumpf.com/" : "https://www.shop.trumpf.com/");
const getAppLauncherTrumpf = () => {
    const { t } = i18nProvider;
    return [
        {
            icon: "uic:mytrumpf-shop",
            label: t("app.header.shopLabel"),
            slug: "trumpf-apps-shop",
            href: getShopUrl(),
            target: "_blank"
        },
        {
            icon: "uic:service-app",
            label: t("app.header.serviceAppLabel"),
            slug: "trumpf-apps-service-app",
            href: `${getTrumpfBaseUrl()}?id=4236`,
            target: "_blank"
        },
        {
            icon: "uic:smart-factory",
            label: t("app.header.smartFactorySuiteLabel"),
            slug: "trumpf-apps-smart-factory-suite",
            href: `${getTrumpfBaseUrl()}?id=6916`,
            target: "_blank"
        }
    ];
};
const getLegalMenuItems = () => {
    const { t } = i18nProvider;
    return [
        {
            label: t("app.header.legalNoticeLabel"),
            slug: "trumpf-meta-legal-notice",
            href: `${getTrumpfBaseUrl()}?id=767`,
            target: "_blank"
        },
        {
            label: t("app.header.privacyPolicyLabel"),
            slug: "trumpf-meta-privacy-policy",
            href: `${getTrumpfBaseUrl()}?id=4244`,
            target: "_blank"
        },
        {
            label: t("app.header.copyrightLabel"),
            slug: "trumpf-meta-copyright",
            href: `${getTrumpfBaseUrl()}?id=769`,
            target: "_blank"
        }
    ];
};

const appHeaderCss = ":root,.uic-theme-responsive{--uxc-app-header-height:52px;--uxc-app-header-expandables-y-offset:56px;--uxc-app-header-expandables-min-width:300px;--uxc-app-header-z-index:400;--uxc-app-header-bg-color:var(--uic-color-blue5);--uxc-app-header-separator-color:var(--uic-color-white);--uxc-app-header-launcher-width:68px}@media only screen and (min-width: 1024px){.uic-theme-responsive{--uxc-app-header-height:68px;--uxc-app-header-expandables-y-offset:72px;--uxc-app-header-launcher-width:85px}}:root,.uic-theme-responsive{--uxc-app-toast-notifications-z-index:350}.uxc-app-header{width:100%;height:var(--uxc-app-header-height);display:block;position:relative}.uxc-app-header__inner{width:100%;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;background:var(--uxc-app-header-bg-color);height:var(--uxc-app-header-height);z-index:var(--uxc-app-header-z-index);position:fixed}.uxc-app-header .uic-sidebar{background:var(--uic-color-blue5);min-width:var(--uxc-app-header-expandables-min-width);top:var(--uxc-app-header-expandables-y-offset);z-index:var(--uic-flyout-z-index);-webkit-transition:none;transition:none}.uxc-app-header .uic-sidebar--opened{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-direction:column;flex-direction:column}.uxc-app-header .uic-sidebar .uxc-app-header__sidebar-meta{border-top:1px solid var(--uxc-app-header-separator-color)}.uxc-app-header .uic-sidebar .uic-menu-item[level=\"0\"]>.uic-menu-item__item{background:var(--uic-color-blue5)}.uxc-app-header .uic-sidebar .uic-menu-item[level=\"0\"]>.uic-menu-item__item:hover{background:var(--uic-menu-item-color-level-0-hover)}.uxc-app-header .uic-sidebar .uic-menu-item[level=\"1\"]>.uic-menu-item__item{background:var(--uic-menu-item-color-level-1)}.uxc-app-header .uic-sidebar .uic-menu-item[level=\"1\"]>.uic-menu-item__item:hover{background:var(--uic-menu-item-color-level-1-hover)}.uxc-app-header uic-flyout{position:fixed;top:var(--uxc-app-header-expandables-y-offset);min-width:var(--uxc-app-header-expandables-min-width)}.uxc-app-header .uic-menu:not(.uic-menu--vertical) .uic-menu-item[level=\"0\"]>.uic-menu-item__dropdown{min-width:var(--uxc-app-header-expandables-min-width)}.uxc-app-header--is-active .uxc-app-header__navigation-left,.uxc-app-header--is-active .uxc-app-header__navigation-right{opacity:1}.uxc-app-header__navigation-left{display:-ms-flexbox;display:flex;position:relative;opacity:0;-webkit-transition:opacity 0.25s ease-in-out;transition:opacity 0.25s ease-in-out}.uxc-app-header__navigation-left .uic-menu-item.uxc-app-header__icon-app-launcher{width:var(--uxc-app-header-launcher-width);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.uxc-app-header__navigation-left .uic-menu-item.uxc-app-header__icon-app-launcher>.uic-menu-item__item{width:100%;background:var(--uic-color-blue4) !important}.uxc-app-header__navigation-left .uic-menu-item.uxc-app-header__icon-app-launcher>.uic-menu-item__item .uic-menu-item__icon--expand{display:none}.uxc-app-header__navigation-left .uic-menu-item.uxc-app-header__icon-app-launcher .uic-menu-item__icon{-webkit-transform:scale(1.3);transform:scale(1.3)}.uxc-app-header__navigation-left .uic-menu-item[slug=trumpf-apps-shop]::before{content:\"\";left:0;top:0;width:100%;height:1px;background:var(--uxc-app-header-separator-color);position:absolute;z-index:1}.uxc-app-header__navigation-left .uxc-app-header__main-navigation{display:-ms-flexbox;display:flex;position:relative}.uxc-app-header__navigation-left .uxc-app-header__main-navigation-burger .uic-sidebar{background:var(--uxc-app-header-bg-color)}.uxc-app-header__navigation-right{right:0;height:100%;display:-ms-flexbox;display:flex;position:absolute;opacity:0;-webkit-transition:opacity 0.25s ease-in-out;transition:opacity 0.25s ease-in-out}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation{display:-ms-flexbox;display:flex;position:relative}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu-item[level=\"0\"]{width:var(--uxc-app-header-height);display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu-item[level=\"0\"]>.uic-menu-item__item{width:100%;-ms-flex-pack:center;justify-content:center}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .ux-icon{font-size:var(--uic-icon-height)}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .ux-icon .ux-icon__inner{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu-item__dropdown{left:auto !important;right:0}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu:not(.uxc-app-header__main-navigation-burger) .uic-menu-item[level=\"0\"]>.uic-menu-item__item .uic-menu-item__icon--expand{display:none}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .uic-menu:not(.uxc-app-header__main-navigation-burger) .uic-menu-item[level=\"0\"]>.uic-menu-item__item .uic-menu-item__inner .uic-menu-item__label{display:none}.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .ux-notification-bell{background:none}@media only screen and (max-width: 1023px){.uxc-app-header__navigation-right .uxc-app-header__meta-navigation .ux-notification-bell .ux-notification-bell__badge{--ux-notification-bell-badge-margin-left-pos:-4px;-webkit-transform:scale(0.8);transform:scale(0.8)}}.uxc-app-header__navigation-right .uxc-app-header__menu-container{display:-ms-flexbox;display:flex}.uic-menu.uxc-app-header__main-navigation-hidden{visibility:hidden;left:0;top:0;position:fixed;z-index:-1;display:inline-block}.uxc-app-header__icon-app-launcher .uic-menu-item[level=\"1\"]>.uic-menu-item__item,.uxc-app-header__menu-sidebar .uic-menu-item[level=\"1\"]>.uic-menu-item__item{background:var(--uic-menu-item-color-level-0)}.uxc-app-header__icon-app-launcher .uic-menu-item[level=\"1\"]:hover>.uic-menu-item__item,.uxc-app-header__menu-sidebar .uic-menu-item[level=\"1\"]:hover>.uic-menu-item__item{background:var(--uic-menu-item-color-level-0-hover)}.uxc-app-header__icon-app-launcher .uic-menu-item[level=\"2\"]>.uic-menu-item__item,.uxc-app-header__menu-sidebar .uic-menu-item[level=\"2\"]>.uic-menu-item__item{background:var(--uic-menu-item-color-level-1)}.uxc-app-header__icon-app-launcher .uic-menu-item[level=\"2\"]:hover>.uic-menu-item__item,.uxc-app-header__menu-sidebar .uic-menu-item[level=\"2\"]:hover>.uic-menu-item__item{background:var(--uic-menu-item-color-level-1-hover)}.uxc-app-header__icon-app-launcher .uic-menu-item[level=\"3\"]>.uic-menu-item__item,.uxc-app-header__menu-sidebar .uic-menu-item[level=\"3\"]>.uic-menu-item__item{background:var(--uic-menu-item-color-level-2)}.uxc-app-header__icon-app-launcher .uic-menu-item[level=\"3\"]:hover>.uic-menu-item__item,.uxc-app-header__menu-sidebar .uic-menu-item[level=\"3\"]:hover>.uic-menu-item__item{background:var(--uic-menu-item-color-level-2-hover)}uxc-app-header uic-badge .uic-badge__content{-webkit-box-sizing:border-box;box-sizing:border-box;height:18px}";
const UxcAppHeaderStyle0 = appHeaderCss;

const AppHeader = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.menuWillChange = createEvent(this, "uicMenuChange", 7);
        this.logoutClicked = createEvent(this, "uicLogout", 6);
        this.menuToggle = createEvent(this, "uicMenuToggle", 6);
        this.baseClass = "uxc-app-header";
        this.handleAppInfoSlotChange = () => {
            this.isAppInfoSlotFilled = this.element.querySelector('[slot="app-info"]') !== null;
        };
        /** Ghost main menu element used for bounds calculation */
        this.menuMainGhost = null;
        /** Width of main menu bar */
        this.menuMainWidth = 0;
        /** Width of app header element */
        this.elementWidth = 0;
        /** I18N subscriber ID */
        this.i18nSubscriberId = "";
        /** Notifications subscriber ID */
        this.notificationsSubscriberId = "";
        /** Observer unsubscribe handlers */
        this.unsubscribeUserClient = null;
        this.debouncedResize = debounce(() => {
            this.handleBreakpoints();
            this.handleNavigationBarWidth();
        }, 50);
        /** Handle mouse clicks outside the header */
        this.handleClickOutside = (event) => {
            if (event.target.closest("uxc-app-header") !== this.element) {
                this.collapseOtherMenus();
                switch (this.activeToggle) {
                    case "":
                    case headerDialogs.NOTIFICATIONS:
                        break;
                    default:
                        this.activeToggle = "";
                        break;
                }
            }
        };
        /** Handle breakpoints */
        this.handleBreakpoints = () => {
            this.elementWidth = this.element.clientWidth;
            this.isMobile = this.elementWidth < this.breakpointMobile;
        };
        /** Internal storage for the meta navigation data */
        this.metaNavigationData = {
            titlebar: [],
            sidebar: []
        };
        this.updateMetaNavigation = () => {
            const { t } = i18nProvider;
            const { isMobile, disableHelp, disableLegalMenuItems, disableSettings, helpNavigation, settingsNavigation, toolbarNavigation, keepHelpInTitleBar, keepSettingsInTitleBar, isAppInfoSlotFilled } = this;
            const metaNavigationData = {
                titlebar: [],
                sidebar: []
            };
            const appInfoMenuItems = isAppInfoSlotFilled
                ? [
                    {
                        label: t("app.header.softwareInformation"),
                        slug: headerDialogs.INFO
                    }
                ]
                : [];
            const helpNavigationItems = disableLegalMenuItems
                ? helpNavigation
                : [...getLegalMenuItems(), ...appInfoMenuItems, ...helpNavigation];
            const toolbarNavigationItems = [];
            if (Array.isArray(toolbarNavigation) && toolbarNavigation.length > 0) {
                toolbarNavigation.forEach((menuItem) => {
                    if (toolbarNavigationItems.length < 3 && isStringNotEmpty(menuItem.icon)) {
                        toolbarNavigationItems.push(menuItem);
                        if (isMobile === false || menuItem.toggle) {
                            metaNavigationData.titlebar.push(menuItem);
                        }
                        else {
                            metaNavigationData.sidebar.push(menuItem);
                        }
                    }
                });
            }
            if (!disableSettings && Array.isArray(settingsNavigation)) {
                const settingsMetaMenuItem = {
                    icon: headerIcons.SETTINGS,
                    slug: headerDialogs.SETTINGS,
                    label: t("app.header.settingsLabel"),
                    items: settingsNavigation
                };
                if (isMobile === false || keepSettingsInTitleBar) {
                    metaNavigationData.titlebar.push(settingsMetaMenuItem);
                }
                else {
                    metaNavigationData.sidebar.push(settingsMetaMenuItem);
                }
            }
            if (!disableHelp && Array.isArray(helpNavigation)) {
                const helpMetaMenuItem = {
                    icon: headerIcons.HELP,
                    slug: headerDialogs.HELP,
                    label: t("app.header.helpLabel"),
                    items: helpNavigationItems
                };
                if (isMobile === false || keepHelpInTitleBar) {
                    metaNavigationData.titlebar.push(helpMetaMenuItem);
                }
                else {
                    metaNavigationData.sidebar.push(helpMetaMenuItem);
                }
            }
            this.metaNavigationData = metaNavigationData;
        };
        /** Handle width of navigation bar based on available space */
        this.handleNavigationBarWidth = () => {
            if (this.menuMainGhost === null) {
                return;
            }
            if (this.disableMainNavigationBar) {
                this.isNavigationBarActive = false;
                return;
            }
            this.menuMainWidth = this.menuMainGhost.offsetWidth;
            const menuApps = this.element.querySelector("." + this.baseClass + "__app-launcher") || null;
            const menuMeta = this.element.querySelector("." + this.baseClass + "__meta-navigation") || null;
            const elementWidth = this.element.clientWidth;
            if (elementWidth >= this.breakpointMobile) {
                const menuAppsWidth = menuApps !== null ? menuApps.offsetWidth : 0;
                const menuMetaWidth = menuMeta !== null ? menuMeta.offsetWidth : 0;
                const menuMainWidthDynamic = elementWidth - menuAppsWidth - menuMetaWidth;
                this.isNavigationBarActive = menuMainWidthDynamic >= this.menuMainWidth;
            }
            else {
                this.isNavigationBarActive = false;
            }
        };
        this.handleNotifications = () => {
            this.notificationsCounter = getNotificationProvider().counter;
        };
        /** Use TrumpfUserClient to fetch userData from API */
        this.initTrumpfUserClient = async () => {
            const { websiteBaseUrl, websitePaths } = getConfig();
            this.removeTrumpfUserClient();
            const trumpfUserClient = getTrumpfUserClient();
            this.unsubscribeUserClient = trumpfUserClient.subscribe(() => {
                this.activeUserData = trumpfUserClient.getBaseUser();
            });
            await trumpfUserClient.getUserData();
            this.activeUserData = trumpfUserClient.getBaseUser();
            this.userProfileUrl = `${websiteBaseUrl}${websitePaths.userProfile}`;
        };
        this.removeTrumpfUserClient = () => {
            if (this.unsubscribeUserClient !== null) {
                this.unsubscribeUserClient();
                this.unsubscribeUserClient = null;
            }
        };
        this.handleLogout = () => {
            this.logoutClicked.emit();
            if (this.unsubscribeUserClient !== null) {
                this.activeUserData = null;
                getAuthClient().deleteAccessToken();
            }
        };
        this.handleMainMenuChange = (event) => {
            const { current, element } = event.detail;
            if (element.slug === headerDialogs.INFO) {
                event.stopPropagation();
                event.preventDefault();
                return;
            }
            if (!element || element.href || element.toggle) {
                return;
            }
            this.activeMenuSlug = current;
            if (this.activeToggle === headerDialogs.BURGER_MENU) {
                return;
            }
            this.activeToggle = "";
        };
        this.handleMainMenuClick = (event) => {
            const menuItem = event.target.closest(".uic-menu-item");
            const menu = event.target.closest(".uic-menu");
            const isInSidebar = menu.closest("uic-sidebar") !== null;
            this.collapseOtherMenus(menu);
            if (menuItem.toggle) {
                return;
            }
            if (this.activeToggle !== "" &&
                menuItem.level === 0 &&
                Array.isArray(menuItem.items) &&
                menuItem.items.length > 0 &&
                !menuItem.expanded) {
                window.setTimeout(() => {
                    menuItem.expanded = true;
                }, 20);
            }
            if (menuItem.slug === headerDialogs.INFO) {
                this.collapseOtherMenus();
                window.setTimeout(() => {
                    this.activeToggle = headerDialogs.INFO;
                    this.element.querySelector(`uic-menu-item[slug="${headerDialogs.HELP}"]`).selected = true;
                    menuItem.selected = false;
                }, 20);
                return;
            }
            if (!isInSidebar) {
                this.activeToggle = "";
            }
        };
        this.handleMainMenuToggle = (event) => {
            const { element, selected, slug } = event.detail;
            if (element.level === 0) {
                this.activeToggle = selected ? slug : "";
            }
        };
        this.handleToggleMenuChange = (event) => {
            const { current } = event.detail;
            this.activeToggle = current;
            if (this.activeToggle !== "") {
                this.collapseOtherMenus(event.target);
            }
            this.menuToggle.emit(event.detail.current);
        };
        this.collapseOtherMenus = (menu) => {
            this.element.querySelectorAll(`.${this.baseClass}__inner .uic-menu`).forEach((el) => {
                if (el !== menu) {
                    el.collapseAll();
                }
            });
        };
        this.renderMainNavigationBurger = () => {
            const { t } = i18nProvider;
            const { baseClass, activeToggle, handleToggleMenuChange, disableMenuLabel } = this;
            return (h("uic-menu", { class: `${baseClass}__main-navigation-burger`, name: "app-header-toggle-nav", "auto-collapse": false, current: activeToggle, "context-element-selector": "uxc-app-header", items: [
                    {
                        icon: headerIcons.BURGER_MENU,
                        slug: headerDialogs.BURGER_MENU,
                        label: disableMenuLabel ? "" : t("app.header.menuLabel")
                    }
                ], onUicMenuChange: handleToggleMenuChange, toggle: true }));
        };
        this.renderMenuSidebar = (position) => {
            const { baseClass, activeToggle, activeMenuSlug, metaNavigationData } = this;
            const metaMenuItems = metaNavigationData.sidebar;
            return (h("uic-sidebar", { class: `${baseClass}__menu-sidebar`, opened: activeToggle === headerDialogs.BURGER_MENU, side: position, alignHeader: true }, h("div", { class: `${baseClass}__sidebar-navigation` }, h("uic-menu", { class: `${baseClass}__sidebar-navigation-main`, name: "app-header-main-nav", current: activeMenuSlug, "context-element-selector": "uxc-app-header", items: this.mainNavigation, onUicMenuChange: this.handleMainMenuChange, vertical: true })), metaMenuItems.length > 0 && (h("div", { class: `${baseClass}__sidebar-meta` }, h("uic-menu", { class: `${baseClass}__sidebar-navigation-meta`, name: "app-header-main-nav", current: activeMenuSlug, "context-element-selector": "uxc-app-header", items: metaMenuItems, onUicMenuChange: this.handleMainMenuChange, onClick: this.handleMainMenuClick, vertical: true })))));
        };
        this.renderMetaNav = () => {
            const { t } = i18nProvider;
            const { baseClass, activeToggle, disableNotifications, disableProfile, activeMenuSlug, notificationsCounter, metaNavigationData, handleMainMenuClick, handleMainMenuChange, handleMainMenuToggle, handleToggleMenuChange } = this;
            const metaMenuItems = metaNavigationData.titlebar;
            const showNotifications = !disableNotifications;
            const showProfile = !disableProfile;
            return (h("div", { class: `${baseClass}__meta-navigation` }, h("div", { class: `${baseClass}__menu-container` }, metaMenuItems.length > 0 && (h("uic-menu", { name: "app-header-main-nav", class: `${baseClass}__meta-navigation-bar`, items: metaMenuItems, current: activeMenuSlug, "context-element-selector": "uxc-app-header", onUicMenuChange: handleMainMenuChange, onUicMenuToggle: handleMainMenuToggle, onClick: handleMainMenuClick }))), h("div", { class: `${baseClass}__menu-container` }, (showNotifications || showProfile) && (h("uic-menu", { name: "app-header-toggle-nav", class: `${baseClass}__toggle-nav`, current: activeToggle, "context-element-selector": "uxc-app-header", onUicMenuChange: handleToggleMenuChange, toggle: true }, showNotifications && (h("uic-menu-item", { label: t("app.header.notificationsLabel"), slug: headerDialogs.NOTIFICATIONS, badge: notificationsCounter, icon: headerIcons.NOTIFICATIONS })), showProfile && (h("uic-menu-item", { icon: headerIcons.USER, label: t("app.header.userLabel"), slug: headerDialogs.USER })))))));
        };
        this.appsNavigation = undefined;
        this.mainNavigation = [];
        this.settingsNavigation = [];
        this.helpNavigation = [];
        this.toolbarNavigation = [];
        this.disableApps = false;
        this.disableSettings = false;
        this.disableHelp = false;
        this.disableProfile = false;
        this.disableNotifications = false;
        this.disableMenuLabel = false;
        this.disableMainNavigationBar = false;
        this.disableLegalMenuItems = false;
        this.breakpointMobile = 1024;
        this.keepSettingsInTitleBar = false;
        this.keepHelpInTitleBar = false;
        this.menuPosition = "left";
        this.activeMenuSlug = "";
        this.activeToggle = "";
        this.userData = null;
        this.userProfileUrl = null;
        this.notificationsCounter = undefined;
        this.language = undefined;
        this.isNavigationBarActive = undefined;
        this.isMobile = undefined;
        this.activeUserData = null;
        this.sidebarNotifications = null;
        this.isAppInfoSlotFilled = false;
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => {
            this.updateMetaNavigation();
            forceUpdate(this);
        });
        this.notificationsSubscriberId = getNotificationProvider().subscribe(this.handleNotifications);
        if (this.userData === null && !this.disableProfile) {
            this.initTrumpfUserClient();
        }
        document.addEventListener("click", this.handleClickOutside);
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
        getNotificationProvider().unsubscribe(this.notificationsSubscriberId);
        this.removeTrumpfUserClient();
        document.removeEventListener("click", this.handleClickOutside);
    }
    componentWillLoad() {
        if (this.disableMainNavigationBar) {
            this.isNavigationBarActive = false;
        }
        if (this.notificationsCounter === undefined) {
            this.notificationsCounter = getNotificationProvider().counter;
        }
        this.setLanguage();
        this.setUserData();
        this.updateMetaNavigation();
        this.handleAppInfoSlotChange();
    }
    componentDidLoad() {
        this.debouncedResize();
        this.handleAppInfoSlotChange();
    }
    /** Handle language prop change */
    setLanguage() {
        if (isStringNotEmpty(this.language)) {
            i18nProvider.changeLanguage(this.language);
        }
    }
    /** Handle userData */
    setUserData() {
        if (this.userData === null) {
            this.activeUserData = null;
            if (!this.disableProfile) {
                this.initTrumpfUserClient();
            }
        }
        else {
            this.removeTrumpfUserClient();
            this.activeUserData = this.userData;
        }
    }
    /** Handle activeToggle change */
    handleActiveToggle() {
        if (this.sidebarNotifications !== null) {
            this.sidebarNotifications.opened = this.activeToggle === headerDialogs.NOTIFICATIONS;
        }
        this.element.querySelectorAll(`uic-menu-item[level="0"][toggle]`).forEach((item) => {
            if (!this.activeToggle || item.slug !== this.activeToggle) {
                item.selected = false;
            }
        });
    }
    /** Handle breakpoint settings change */
    handleBreakpointSettings() {
        this.debouncedResize();
    }
    /** Handle meta navigation changes */
    handleMetaNavigationData() {
        this.updateMetaNavigation();
    }
    /** Listen to window resize events */
    onResize() {
        this.debouncedResize();
    }
    /** Listen to uicAppSidebarNotifications event */
    handleAppSidebarNotificationsMounted(event) {
        const sidebar = this.element.parentElement.querySelector("uxc-app-sidebar-notifications");
        this.sidebarNotifications = sidebar || event.target;
        if (this.sidebarNotifications && this.sidebarNotifications.opened && !this.disableNotifications) {
            this.activeToggle = headerDialogs.NOTIFICATIONS;
        }
        this.debouncedResize();
    }
    closeFlyout() {
        const helpMenu = this.element.querySelector(`uic-menu-item[slug="${headerDialogs.HELP}"]`);
        const helpMenuItems = helpMenu.querySelectorAll(`uic-menu-item`);
        if (this.activeToggle === headerDialogs.INFO && Array.from(helpMenuItems).filter((item) => item.selected).length === 0) {
            helpMenu.selected = false;
        }
        this.activeToggle = "";
    }
    render() {
        const { t } = i18nProvider;
        const { baseClass, disableApps, disableHelp, disableProfile, disableSettings, isMobile, isNavigationBarActive, keepHelpInTitleBar, keepSettingsInTitleBar, menuPosition, activeUserData, userProfileUrl, activeMenuSlug, activeToggle, handleLogout, handleMainMenuChange, handleMainMenuClick } = this;
        const appLauncherItems = disableApps
            ? this.appsNavigation || []
            : [...(this.appsNavigation || []), ...getAppLauncherTrumpf()];
        const showAppHeaderContent = isMobile !== undefined && isNavigationBarActive !== undefined;
        const hideNavigationBurger = isNavigationBarActive !== false ||
            (this.mainNavigation.length <= 0 && (disableSettings || keepSettingsInTitleBar) && (disableHelp || keepHelpInTitleBar));
        return (h(Host, { key: 'e603b731a9a68ad5db2fddd1b6803cdf0b45595e', class: {
                [`${baseClass}`]: true,
                [`${baseClass}--has-navigation-bar`]: isNavigationBarActive,
                [`${baseClass}--is-active`]: showAppHeaderContent
            } }, h("div", { key: '5c682571a3582adc15940a145f03ad8de409a838', class: `${baseClass}__inner` }, h("div", { key: 'ac8a6eaf6b976c6ab4dac2254d1d96788e51ed19', class: `${baseClass}__navigation-left` }, h("div", { key: '9666782465ef17c6658a26034650b65717b68014', class: `${baseClass}__app-launcher` }, h("uic-menu", { key: '3afb8927fc7e7249234fcb8fa27e529c78c90115', name: "app-header-main-nav", current: activeMenuSlug, class: `${baseClass}__apps-nav`, "context-element-selector": "uxc-app-header", onUicMenuChange: handleMainMenuChange, onClick: handleMainMenuClick }, h("uic-menu-item", { key: '6694cafa51aa68521e8c68ba9bc3c51fc7ba26fc', class: `${baseClass}__icon-app-launcher`, icon: headerIcons.APP_LAUNCHER, slug: headerDialogs.APP_LAUNCHER, items: appLauncherItems, selected: activeToggle === headerDialogs.APP_LAUNCHER, expanded: activeToggle === headerDialogs.APP_LAUNCHER }))), h("div", { key: '075a11449edccc0c954dd38ebba72d4ed783b534', class: `${baseClass}__main-navigation` }, !hideNavigationBurger && menuPosition === "left" && this.renderMainNavigationBurger(), isNavigationBarActive === true && (h("uic-menu", { key: '4a92823926442e981046fe5f09dccd100314d078', class: `${baseClass}__main-navigation-bar`, name: "app-header-main-nav", current: activeMenuSlug, "context-element-selector": "uxc-app-header", items: this.mainNavigation, onUicMenuChange: handleMainMenuChange, onClick: handleMainMenuClick })))), h("div", { key: '21101e3f7648ce5e0b0ef89684242eb811ded751', class: `${baseClass}__navigation-right` }, this.renderMetaNav(), !hideNavigationBurger && menuPosition === "right" && this.renderMainNavigationBurger())), h("uic-flyout", { key: '4da7247ed19076aeeb4633f92c612b8549f0cf24', position: "right", name: headerDialogs.USER, opened: !disableProfile && activeToggle === headerDialogs.USER }, h("div", { key: 'd4b4a09e068931c8f2b7c3fb987698b9253f2aa8', slot: "content" }, h("uic-app-user-info", { key: 'ef24e567c91714e9aedf3338a0f22c096bced279', noDataText: t("app.header.noUserDataLabel"), userData: activeUserData, userProfileText: t("app.header.userProfileLinkText"), userProfileUrl: userProfileUrl }, h("slot", { key: 'dd78a2d3321450a2e1025aad1e2e5b8ac3b9e5b2', name: "user-dialog" }))), activeUserData !== null && (h("uic-button", { key: '3f6ddcb6d9614c92ec7fe4cc5ee555e84aa672ea', slot: "footer", variant: "footer", onClick: handleLogout }, t("app.header.logoutButton"))), h("uic-button", { key: '11f622c8d1cf33fe13d9080d106f72cfaca95656', slot: "footer", variant: "footer-primary", onClick: () => this.closeFlyout() }, t("app.header.closeButton"))), h("uic-flyout", { key: '41bd2e57134f7a7e663d3a1e4bb288445e9933dd', position: "right", name: headerDialogs.INFO, opened: this.isAppInfoSlotFilled && activeToggle === headerDialogs.INFO, style: { "--uic-flyout-width": "640px", "--uic-flyout-content-padding": "0" } }, h("div", { key: '955309f5de6da80ba5e23be20fe721d5454a2678', slot: "content" }, h("slot", { key: '03bb6df7bc5c8951f93592c8f823a16509168abd', name: "app-info" })), h("uic-button", { key: '440fdee331168460ed785aa08f65c5c3004a2ba2', slot: "footer", variant: "footer-primary", onClick: () => this.closeFlyout() }, t("app.header.closeButton"))), isNavigationBarActive === false && this.renderMenuSidebar(menuPosition), h("uic-menu", { key: 'e39f91f87cc301c7a87d1c4f625e6324f7b035e7', name: "main-navigation-hidden", class: `${baseClass}__main-navigation-hidden`, items: this.mainNavigation, ref: (el) => (this.menuMainGhost = el) })));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "language": ["setLanguage"],
        "userData": ["setUserData"],
        "activeToggle": ["handleActiveToggle"],
        "breakpointMobile": ["handleBreakpointSettings"],
        "disableHelp": ["handleMetaNavigationData"],
        "disableInfo": ["handleMetaNavigationData"],
        "disableLegalMenuItems": ["handleMetaNavigationData"],
        "disableSettings": ["handleMetaNavigationData"],
        "helpNavigation": ["handleMetaNavigationData"],
        "settingsNavigation": ["handleMetaNavigationData"],
        "toolbarNavigation": ["handleMetaNavigationData"],
        "isMobile": ["handleMetaNavigationData"],
        "keepHelpInTitleBar": ["handleMetaNavigationData"],
        "keepSettingsInTitleBar": ["handleMetaNavigationData"]
    }; }
};
AppHeader.style = UxcAppHeaderStyle0;

export { AppHeader as uxc_app_header };

//# sourceMappingURL=uxc-app-header.entry.js.map